// extracted by mini-css-extract-plugin
module.exports = {"empty_Records":"EmptyRecordsV2_empty_Records__15JD8","description":"EmptyRecordsV2_description__qZLd3"};